import { createApp } from "vue";
import App from "./App.vue";
import { createPinia } from "pinia";
import { createPersistedState } from "pinia-persistedstate-plugin";
import router from "./router/index";
// import { i18n } from "./lang";
import umengPlugin from '@/plugins/umeng'

const pinia = createPinia();
pinia.use(createPersistedState({ storage: window.sessionStorage }));
const app = createApp(App);
app.use(router);
app.use(pinia);
app.use(umengPlugin)
// app.use(i18n);
app.mount("#app");
